<template>
  <div>
    <div
      :class="`custom-global-skeleton tw-cursor-pointer tw-select-none tw-pr-[25px] tw-bg-[#ffffff] tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-self-stretch tw-border-0 tw-border-b-[1px] tw-border-solid tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-border-[#EFF0F1] ${
        showIcon ? 'tw-rounded-[6px]' : 'tw-rounded-t-[6px]'
      }`"
    >
      <!--
 <div class="tw-flex tw-flex-row tw-justify-start tw-items-center">
        <div class="tw-py-[20px]">
          <CustomCheckBox
            v-model:is-checked="selectAll"
            class="tw-h-[20px] tw-ml-[25px] !tw-mb-0"
            size="20px"
          />
        </div>
        <div
          class="tw-py-[20px] tw-pr-[25px] w-font-Poppins tw-text-[18px] tw-font-[600] tw-text-[#211F58]"
        >
          <div
            class="custom-global-skeleton-pulse tw-h-[18px] tw-w-[60px]"
          ></div>
        </div>
        <div
          class="custom-global-skeleton-pulse tw-h-[18px] tw-w-[150px]"
        ></div>
      </div>
      <div>
        <span class="float-right button-arrow dropdown-button-arrow-img">
          <img
            class="collap-button-arrow-down-img"
            src="@/assets/img/arrow_down2.svg"
          />
        </span>
      </div> 
-->
    </div>
    <div
      v-for="item in [1, 2, 3]"
      :key="item"
      :class="`custom-global-skeleton tw-flex tw-flex-col tw-relative assessmentQuestion question ${customClass}`"
    >
      <div
        :class="`custom-global-skeleton tw-flex tw-flex-col tw-relative assessmentQuestion question ${customClass}`"
      >
        <div
          class="custom-global-skeleton tw-flex tw-flex-row tw-justify-start"
        >
          <div class="tw-py-[20px]">
            <CustomCheckBox
              v-model:is-checked="selectAll"
              class="tw-h-[20px] tw-ml-[25px] !tw-mb-0"
              size="20px"
            />
          </div>
          <div
            class="tw-leading-[100%] tw-py-[20px] tw-pr-[25px] tw- w-font-Poppins tw-text-[18px] tw-font-[600] tw-text-[#211F58]"
          >
            <!--
 <div
              class="custom-global-skeleton-pulse tw-h-[18px] tw-w-[60px]"
            ></div>
          </div>
          <div class="tw-pt-[20px]">
            <div
              class="custom-global-skeleton-pulse tw-h-[18px] tw-w-[250px] tw-mb-[25px]"
            ></div>
            <div
              class="custom-global-skeleton-pulse tw-h-[18px] tw-w-[100px] tw-mb-[25px]"
            ></div> 
-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Ref, ref } from "vue";
import CustomCheckBox from "@/components/common/customCheckBox.vue";
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  /** The order number of sub question category */
  orderNumber: {
    type: Number,
    default: 1,
  },
  selectedQuestions: {
    type: Array as () => any[],
    default: () => [],
  },
  customClass: {
    type: String,
    default: "",
  },
});
const selectAll: Ref<boolean> = ref(false);
const showIcon: Ref<boolean> = ref(false);
const suggestion = 0;
</script>
<style scoped>
.open {
  opacity: 1;
  height: auto;
}

.assessmentQuestion {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eff0f1;
  background: #fff;
  width: 100%;
  max-width: 1060px;

  @media (max-width: 1536px) {
    max-width: 100%;
  }
}

.complete {
  background: linear-gradient(
      0deg,
      rgba(1, 137, 61, 0.15) 0%,
      rgba(1, 137, 61, 0.15) 100%
    ),
    #fff;
}

.exposure {
  background: linear-gradient(
      0deg,
      rgba(247, 85, 60, 0.15) 0%,
      rgba(247, 85, 60, 0.15) 100%
    ),
    #fff;
}

.collap-button-arrow-down-img {
  transform: rotate(180deg);
}

.question:last-child {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.skeleton-text {
  width: 68px;
  height: 18px;
}
</style>
